import { render, staticRenderFns } from "./ForSuppliers.vue?vue&type=template&id=29a13ea9"
import script from "./ForSuppliers.vue?vue&type=script&lang=js"
export * from "./ForSuppliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports